import { render } from "./BaseEmailAddresses.vue?vue&type=template&id=54bfe3e5"
import script from "./BaseEmailAddresses.vue?vue&type=script&lang=js"
export * from "./BaseEmailAddresses.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__